export default __webpack_public_path__ + "static/media/hand-right-back.a5d94e05.png";